import { View } from "@/components/ui";
import { openBrowser } from "@/lib/open-browser";
import { Typography } from "@/components/shared/typography";
import { links } from "@/constants";

export const AgreeTerms = () => {
  return (
    <View>
      <Typography variant="body-sm" className="inline">
        I agree and understand that I'm purchasing a service subject to
      </Typography>
      <Typography
        variant="body-sm"
        className="ml-[2px] inline cursor-pointer"
        color="info"
        onClick={() => {
          openBrowser(links.legalTermCondition);
        }}
      >
        Luce Maintenance Group Terms of Usage
      </Typography>
    </View>
  );
};
